import {
  GetRoadmapsByCustomerResponse,
  RoadmapsClient,
} from "../../../../../customer-experience/src/lib/ShiOneClient";
import { useApi } from "../../../../../customer-experience/src/v2/src/utils";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ROADMAPS_OVERVIEW } from "../utils/constants";

export default function useGetRoadmapsByCustomerId() {
  const api = useApi(RoadmapsClient);

  const getRoadmaps = async () => {
    return await api.getRoadmaps();
  };

  return useQuery<GetRoadmapsByCustomerResponse>({
    queryKey: [CACHE_KEY_ROADMAPS_OVERVIEW],
    queryFn: () => getRoadmaps(),
  });
}
